import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VLayout,{attrs:{"text-center":"","wrap":""}},[_c(VFlex,{attrs:{"xs12":"","mb-4":""}},[_c('GoogleSignin'),(_vm.authErrors.length > 0)?_c('p',[_vm._v("There was an error logging in to your account.")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }